import Private from './Private'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import MapPageWrapper from 'components/map/PageWrapper'

function MapSearch() {
  const { t } = useTranslation()
  return (
    <Private>
      <Helmet>
        <title>Koç Office Free - {t('nav-menu-items.map-search')} </title>
        <meta
          name="description"
          content="Office Free ile ister şirketinden, ister Koç Topluluğu ortak ofislerinden çalışma planı gerçekleştirebilir, istersen de uzaktan çalışma bildirimi yapabilirsin. Ya da kampüs içi hizmetlerden yararlanabilirsin."
        />
      </Helmet>

      <MapPageWrapper />
    </Private>
  )
}

export default MapSearch
